import React, { useRef } from "react";
import { SubtitleSurveyLabel, SubtitleLabelSurvey } from "theme/survey";
import { Option } from "contexts/survey-context/survey.interface";

export interface TextProps {
  questionId: number;
  title: string;
  subtitle: string;
  items?: Option[];
  onChange: (key: number, selected: string[], value?: string) => void;
}

const TextBox = (props: TextProps) => {
  const ref = useRef<HTMLTextAreaElement>()

  const onchange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(props?.questionId, [`${props.items[0]?.optionId}`], e.target.value)
  }

  return (
    <>
      <div className="p-2 w-full label-survey">
        <SubtitleSurveyLabel className="font-black text-2xl text-center md:text-3xl subtitle-option">
          {props.title}
        </SubtitleSurveyLabel>
        <SubtitleLabelSurvey className="text-lg md:text-xl subtitle-option">
          {props.subtitle}
        </SubtitleLabelSurvey>
      </div>
      <div className={`flex flex-col my-2 px-2 gap-4 md:mx-auto w-full text-black input-survey-textarea-container`}>
        <textarea ref={ref} className={`input-survey-textarea ${props?.questionId === 12 ? 'input-survey-textarea-simple' : ''}`} placeholder={props.items[0]?.option} onChange={onchange} maxLength={props?.questionId === 13 ? 250 : 320} />
        {props?.questionId === 13 && <p>{ref?.current?.value?.length ?? 0}/250 caracteres</p>}
      </div>
    </>
  )
}

export default TextBox